export enum EEndpointApp {
  // Detail = 'detail',
  List = 'list',
  Form = 'form',
  // Forms = 'forms',
  Account = 'account',
  Auth = 'auth',
  SignIn = 'sign-in',
  SignUp = 'sign-up',
  SignOut = 'sign-out',
  // ResetPassword = 'reset-password',
  ForgotPassword = 'forgot-password',
  // Catalog = 'catalog',
  Overview = 'overview',
  QrCode = 'qrcode',
  CustomDomain = 'custom-domain',
  ArchiveReview = 'archive-review',
  Template = 'template',
  Analytics = 'analytics',
  ContactUs = 'contact-us',
  Teams = 'teams',
  Invitations = 'invitations',
  Members = 'members',
  Profile = 'profile',
  Customers = 'customers',
  Hits = 'hits',
  Subscribes = 'subscribes',
  Tariffs = 'tariffs',
  PaymentTransactions = 'payment-transactions',
  Design = 'design',
  Setup = 'setup',
  View = 'view',
  Security = 'security',
  FeaturesPricing = `features-and-pricing`,
  AuthorizedDevices = `authorized-devices`,

  // FORMS_LIST = `/${EEndpointApp.Forms}/${EEndpointApp.List}`,
  AUTH_SIGN_IN = `/${EEndpointApp.Auth}/${EEndpointApp.SignIn}`,
  AUTH_SIGN_UP = `/${EEndpointApp.Auth}/${EEndpointApp.SignUp}`,
  AUTH_SIGN_OUT = `/${EEndpointApp.Auth}/${EEndpointApp.SignOut}`,
  AUTH_VERIFY_EMAIL = `/${EEndpointApp.Auth}/verify-email`,
  AUTH_FORGOT_PASSWORD = `/${EEndpointApp.Auth}/${EEndpointApp.ForgotPassword}`,
  // ACCOUNT_SUCCESSFULLY_DELETED = '/account-successfully-deleted',

  ACCOUNT_TEAMS = `/${EEndpointApp.Teams}`,
  ACCOUNT_TEAMS_OVERVIEW = `/${EEndpointApp.Teams}/${EEndpointApp.Overview}`,
  ACCOUNT_PROFILE = `/${EEndpointApp.Account}/${EEndpointApp.Profile}`,
  ACCOUNT_SECURITY = `/${EEndpointApp.Account}/${EEndpointApp.Security}`,
  ACCOUNT_AUTHORIZED_DEVICES = `/${EEndpointApp.Account}/${EEndpointApp.AuthorizedDevices}`,
  ACCOUNT_FEATURES_PRICING = `/${EEndpointApp.FeaturesPricing}`,
  ACCOUNT_SUCCESSFULLY_DELETED = '/account-successfully-deleted',
  CONTACT_US = `/${EEndpointApp.ContactUs}`,

  // CATALOG_OVERVIEW = `/${EEndpointApp.Catalog}/${EEndpointApp.Overview}`,
  // CATALOG_FORM = `/${EEndpointApp.Catalog}/${EEndpointApp.Form}`,

  QRCODE = `/${EEndpointApp.QrCode}`,
  QRCODE_OVERVIEW = `/${EEndpointApp.QrCode}/${EEndpointApp.Overview}`,
  QRCODE_ARCHIVE_REVIEW = `/${EEndpointApp.QrCode}/${EEndpointApp.ArchiveReview}`,
  QRCODE_ANALYTICS = `/${EEndpointApp.QrCode}/${EEndpointApp.Analytics}`,
  QRCODE_FORM_NEW = `/${EEndpointApp.QrCode}/${EEndpointApp.Form}/new`,
  QRCODE_TEMPLATE = `/${EEndpointApp.QrCode}/${EEndpointApp.Template}`,
  QRCODE_TEMPLATE_OVERVIEW = `/${EEndpointApp.QrCode}/${EEndpointApp.Template}/${EEndpointApp.Overview}`,
  QRCODE_TEMPLATE_FORM_NEW = `/${EEndpointApp.QrCode}/${EEndpointApp.Template}/new`,

  CUSTOM_DOMAIN = `/${EEndpointApp.CustomDomain}`,

  CUSTOMERS = `/${EEndpointApp.Customers}`,
  QR_CODES = `/${EEndpointApp.QrCode}`,
  HITS = `/${EEndpointApp.Hits}`,
  TARIFFS = `/${EEndpointApp.Tariffs}`,
  SUBSCRIBES = `/${EEndpointApp.Subscribes}`,
  PAYMENT_TRANSACTIONS = `/${EEndpointApp.PaymentTransactions}`,
}
